document.addEventListener('DOMContentLoaded', () => {
    // Tabs
    const tabs = document.querySelectorAll('.tab');
    const sections = document.querySelectorAll('.product-information-section, .content-section');
    const tabsScroll = document.querySelector('.tabs-scroll');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const targetId = tab.getAttribute('data-target');
            const targetElement = document.getElementById(targetId);

            targetElement.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });

            scrollToTab(tab);
        });
    });

    const makeActive = id => {
        tabs.forEach(tab => {
            tab.classList.remove('active');
            if (tab.getAttribute('data-target') === id) {
                tab.classList.add('active');
                scrollToTab(tab);
            }
        });
    };

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                if (entry.target.classList.contains('product-information-section')) {
                    makeActive(entry.target.id);
                } else if (entry.target.classList.contains('content-section')) {
                    makeActive(entry.target.dataset.sectionId);
                }
            }
        });
    }, { threshold: 1 });

    sections.forEach(section => {
        observer.observe(section);
    });

    function scrollToTab(selectedTab) {
        if (!tabsScroll) return;
        const selectedTabLeft = selectedTab.getBoundingClientRect().left;
        const selectedTabRight = selectedTab.getBoundingClientRect().right;
        const tabsScrollLeft = tabsScroll.getBoundingClientRect().left;
        const tabsScrollRight = tabsScroll.getBoundingClientRect().right;

        if (selectedTabLeft < tabsScrollLeft) {
            tabsScroll.scrollBy({ left: selectedTabLeft - tabsScrollLeft - 20, behavior: 'smooth' });
        }
        else if (selectedTabRight > tabsScrollRight) {
            tabsScroll.scrollBy({ left: selectedTabRight - tabsScrollRight + 20, behavior: 'smooth' });
        }
    }

    // Tech Specs
    var viewMoreButton = document.getElementById('view-more-specs');
    var viewMoreImg = document.getElementById('view-more-img');
    if (viewMoreButton) {
        viewMoreButton.addEventListener('click', function () {
            var hiddenSpecs = document.querySelectorAll('.technical-spec-list li:nth-child(n+10)');
            // Use the button's text to determine the current state
            if (viewMoreButton.textContent === 'View More') {
                // If in "View More" state, show all specs and switch to "View Less"
                hiddenSpecs.forEach(function (spec) {
                    spec.classList.remove('hidden-spec');
                });
                viewMoreButton.textContent = 'View Less';
                if (viewMoreImg) {
                    viewMoreImg.style.transform = 'scaleY(-1)';
                }
            } else {
                // If in "View Less" state, hide the specs beyond the first 5 and switch to "View More"
                hiddenSpecs.forEach(function (spec) {
                    spec.classList.add('hidden-spec');
                });
                viewMoreButton.textContent = 'View More';
                if (viewMoreImg) {
                    viewMoreImg.style.transform = 'scaleY(1)';
                }
            }
        });
    }

    // Compare Products
    const compare_products_wrapper = document.querySelector('.compare-products-wrapper');
    const view_mores = document.querySelectorAll('[view-more]');

    if (compare_products_wrapper && view_mores) {
        const view_more_text = document.querySelector('.compare-products-container').getAttribute('data-more');
        const view_less_text = document.querySelector('.compare-products-container').getAttribute('data-less');
        view_mores.forEach(view_more => {
            view_more.addEventListener('click', function (e) {
                e.preventDefault();
                compare_products_wrapper.classList.toggle('show-more');
                if (compare_products_wrapper.classList.contains('show-more')) {
                    view_more.innerHTML = view_less_text;
                }
                else {
                    view_more.innerHTML = view_more_text;
                }
            });
        })
    }

    document.addEventListener('scroll', () => {
        const productInformation = document.querySelector('.product-information-container');

        if (productInformation) {
            const productTop = productInformation.getBoundingClientRect().top;
            const stickyContainer = productInformation.querySelector('.tabs-container');

            // If the top of the productInformation is above the top of the viewport (i.e., user has scrolled past it)
            if (productTop < 0) {
                if (stickyContainer) stickyContainer.classList.add('is-sticky');
            } else {
                if (stickyContainer) stickyContainer.classList.remove('is-sticky');
            }
        }
    });

});